import React from 'react';
import styled from 'styled-components';

import ReviewLink from './ReviewLink';
import type { ReviewLinksScreenProps } from '@/types';

const ReviewLinksContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
`;

const ReviewLinksScreen: React.FC<ReviewLinksScreenProps> = ({
  reviewLinks,
  addReviewLinkClick,
  primaryColor,
}) => {
  // Filter links to only show enabled ones (TripAdvisor, Yelp, Facebook, Google)
  // This ensures only review platforms marked as enabled in the API response are displayed
  const enabledLinks = reviewLinks.filter((link) => link.enabled);

  return (
    <ReviewLinksContainer>
      {enabledLinks.map((link) => (
        <ReviewLink
          key={link.provider.slug}
          {...link}
          addReviewLinkClick={addReviewLinkClick}
          primaryColor={primaryColor}
        />
      ))}
    </ReviewLinksContainer>
  );
};

export default ReviewLinksScreen;
